<template>
  <v-container fluid>
    <page-header>
      <v-breadcrumbs>
        <v-breadcrumbs-item to="/secure/teachers">Teachers</v-breadcrumbs-item>
        <v-breadcrumbs-divider>/</v-breadcrumbs-divider>
        <v-breadcrumbs-item :to="backRoute">
          {{ teacher ? `${teacher.firstName} ${teacher.lastName}` : "N/A" }}
        </v-breadcrumbs-item>
        <v-breadcrumbs-divider>/</v-breadcrumbs-divider>
        <v-breadcrumbs-item :disabled="true">
          {{this.$route.params.id ? 'Edit':'New'}} Availability
        </v-breadcrumbs-item>
      </v-breadcrumbs>
    </page-header>
    <v-card width="100%" class="mx-auto">
      <v-card-text>
        <v-form ref="form" lazy-validation>
          <v-row>
            <v-col cols="12" lg="6">
                            <v-switch label="Online Only" v-model="onlineOnly"/>

             
              <!-- <v-text-field
                v-model="repeatWeekInterval"
                hide-details
                disabled
                style="width: 50px; display: inline-block"
              />
              week(s) -->
            </v-col>
            <v-col cols="12" lg="6">
               Repeat Every Week<br/>
              <v-btn-toggle multiple v-model="selectedWeekdays">
                <v-btn v-for="day in weekdays" :key="day" :value="day">
                  {{ day }}
                </v-btn>
              </v-btn-toggle>
            </v-col>
            <v-col cols="12" lg="6">
              <v-text-field
                type="date"
                v-model="startDate"
                label="Start Date*"
                prepend-icon="mdi-calendar"
                clearable
                :rules="[rules.required]"
                required
              ></v-text-field>
            </v-col>
            <v-col cols="12" lg="6">
              <v-text-field
                v-model="endDate"
                label="End Date"
                prepend-icon="mdi-calendar"
                type="date"
                :rules="[rules.dateRange(this.startDate, this.endDate)]"
                clearable
              ></v-text-field>
            </v-col>
            <v-col cols="12" lg="6">
              <v-text-field
                v-model="startTime"
                label="Start Time*"
                prepend-icon="mdi-clock-time-four-outline"
                :rules="[rules.required]"
                type="time"
                required
              ></v-text-field>
            </v-col>
            <v-col cols="12" lg="6">
              <v-text-field
                v-model="endTime"
                label="End Time*"
                prepend-icon="mdi-clock-time-four-outline"
                type="time"
                :rules="[rules.required, rules.timeRange(this.startTime, this.endTime)]"
                required
              ></v-text-field>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12" lg="12">
              <v-textarea
                v-model="remark"
                :auto-grow="true"
                rows="1"
                label="Remark"
              />
            </v-col>
          </v-row>
        </v-form>
        <v-card-actions>
          <v-spacer />
          <v-btn :to="backRoute" class="mx-5">Cancel</v-btn>
          <v-btn @click="saveAvailability" color="primary" class="mx-5">{{
            id ? "Update" : "Save"
          }}</v-btn>
          <v-spacer />
        </v-card-actions>
      </v-card-text>
    </v-card>
  </v-container>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import moment from "moment";
const PageHeader = () => import("@/components/common/PageHeader.vue");
import {rules} from "@/store/util/rules.js";


export default {
  data() {
    return {
      id: null,
      startTime: null,
      endTime: null,
      startDate: new moment().format("YYYY-MM-DD"),
      repeatWeekInterval: 1,
      endDate: null,
      selectedWeekdays: [],
      weekdays: ["Mon", "Tue", "Wed", "Thu", "Fri", "Sat", "Sun"],
      remark: "",
      onlineOnly: true,
      availability: {},
      teacher: {},
      backRoute: {
        name: "Teacher",
        params: { id: this.$route.params.teacherId, tab: "tab-availability" },
      },
      rules
    };
  },
  computed: {
    ...mapGetters(["navState", "isAppLoading"]),
  },
  mounted() {
    console.log("initializing availablity.");
    this.initAvailability();
    this.initTeacher();
  },
  components: {
    PageHeader,
  },
  methods: {
    ...mapActions([
      "hideDialog",
      "addMessage",
      "addErrorMessage",
      "addSuccessMessage",
    ]),
    initAvailability() {
      const availabilityId = this.$route.params.id;
      if(availabilityId){
        const params = {
          availabilityId,
        };
        return this.$axios
          .get("/teachers/availability/getById", {params})
          .then((resp) => {
            this.availability = resp.data.data;
  
            this.id = this.availability.id;
            this.startDate = this.availability.startDate;
            this.endDate = this.availability.endDate;
            this.startTime = this.availability.startTime;
            this.endTime = this.availability.endTime;
            this.remark = this.availability.remark;
            this.onlineOnly = this.availability.onlineOnly;
            this.selectedWeekdays = this.availability.daysOfWeek;
          });
      }
    },
    initTeacher() {
      const teacherId = this.$route.params.teacherId
        ? this.$route.params.teacherId
        : null;
      if (teacherId) {
        this.$axios
          .get("teacher/getById", { params: { teacherId: teacherId } })
          .then((resp) => {
            this.teacher = resp.data.data;
          });
      }
    },
    saveAvailability() {
      if (!this.$refs.form.validate()) {
        this.addMessage("Please check your input");
        return;
      }


      if (this.selectedWeekdays == null || this.selectedWeekdays.length < 1) {
        this.addErrorMessage("Please choose days of week");
        return;
      }

      const timezoneOffset = new Date().getTimezoneOffset()

      const data = {
        id: this.id,
        startDate: this.startDate,
        endDate: this.endDate,
        daysOfWeek: this.selectedWeekdays,
        remark: this.remark,
        onlineOnly: this.onlineOnly,
        startTime: this.startTime,
        endTime: this.endTime,
        teacherId: this.teacher.id,
        timezoneOffset: timezoneOffset
        };

      this.$axios
        .post("/teachers/availability/update", data)
        .then((resp) => {
          const savedAvailability = resp.data.data;
          this.availability.id = savedAvailability.id;

          this.addSuccessMessage("Teacher availability updated");
          this.$router.push(this.backRoute);
        })
        .catch((error) => {
          this.addErrorMessage(error.message);
        });
    },
    
  }
};
</script>

<style>
</style>